"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "contain"
  }, [_c("div", {
    staticClass: "header-box"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("xjgd.title")))])]), _vm._v(" "), _c("div", {
    staticClass: "formbody"
  }, [_c("el-form", {
    ref: "dialogForm",
    staticClass: "filter-inline",
    attrs: {
      inline: true,
      model: _vm.orderModel,
      "label-position": "top",
      rules: _vm.dialogRules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("xjgd.selectProject"),
      prop: "projectid"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("xjgd.projectPlaceholder")
    },
    on: {
      change: _vm.selectProjectHaveChange
    },
    model: {
      value: _vm.orderModel.projectid,
      callback: function callback($$v) {
        _vm.$set(_vm.orderModel, "projectid", $$v);
      },
      expression: "orderModel.projectid"
    }
  }, _vm._l(_vm.projectList, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        value: item.id,
        label: item.entryName
      }
    });
  }), 1)], 1), _vm._v(" "), _c("el-form-item", {
    staticStyle: {
      width: "45%"
    },
    attrs: {
      label: _vm.$t("xjgd.orderType"),
      prop: "orderType"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("xjgd.orderTypePlaceholder")
    },
    model: {
      value: _vm.orderModel.orderType,
      callback: function callback($$v) {
        _vm.$set(_vm.orderModel, "orderType", $$v);
      },
      expression: "orderModel.orderType"
    }
  }, [_c("el-option", {
    attrs: {
      label: _vm.$t("xjgd.sbgz"),
      value: "1"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.$t("xjgd.qt"),
      value: " 2"
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("xjgd.selectHandler"),
      prop: "dealUser",
      "label-width": "500'px'"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("xjgd.handlerPlaceholder")
    },
    model: {
      value: _vm.orderModel.dealUser,
      callback: function callback($$v) {
        _vm.$set(_vm.orderModel, "dealUser", $$v);
      },
      expression: "orderModel.dealUser"
    }
  }, _vm._l(_vm.projectUserList, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        value: item.id,
        label: item.name
      }
    });
  }), 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("xjgd.selectCcUser"),
      prop: "sendUsers",
      "label-width": "500'px'"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("xjgd.ccUserPlaceholder"),
      multiple: "",
      clearable: ""
    },
    model: {
      value: _vm.orderModel.sendUsers,
      callback: function callback($$v) {
        _vm.$set(_vm.orderModel, "sendUsers", $$v);
      },
      expression: "orderModel.sendUsers"
    }
  }, _vm._l(_vm.projectUserList, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        value: item.id,
        label: item.name
      }
    });
  }), 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("xjgd.eventDescription")
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "100%",
      "font-size": "18px"
    },
    attrs: {
      type: "textarea",
      maxlength: "200",
      "show-word-limit": "",
      clearable: "",
      rows: "5",
      placeholder: _vm.$t("xjgd.descPlaceholder"),
      resize: "none"
    },
    model: {
      value: _vm.orderModel.desc,
      callback: function callback($$v) {
        _vm.$set(_vm.orderModel, "desc", $$v);
      },
      expression: "orderModel.desc"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("xjgd.sitePhotos")
    }
  }, [_c("el-upload", {
    ref: "elUpload",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      action: "",
      "list-type": "picture-card",
      multiple: "",
      accept: ".jpg,.jpeg,.png,.JPG,.JPEG",
      "auto-upload": false,
      "before-upload": _vm.beforeAvatarUpload,
      limit: 10,
      "on-exceed": _vm.handleExceed,
      "http-request": _vm.imageUpload,
      "on-preview": _vm.handlePictureCardPreview
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c("el-dialog", {
    attrs: {
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("img", {
    attrs: {
      width: "100%",
      src: _vm.dialogImageUrl,
      alt: ""
    }
  })])], 1)], 1), _vm._v(" "), _c("el-button", {
    staticClass: "newOrder",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.createOrderAction
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("xjgd.submitOrder")) + "\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;